export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT = "LOGOUT"
export const PROXY_ROLE = "PROXY_ROLE"
export const PROXY_FAC = "PROXY_FAC"
export const PROXY_ORG = "PROXY_ORG"
export const PROXY = "PROXY"
export const CLEAR_PROXY = "CLEAR_PROXY"
export const SET_MESSAGE = "SET_MESSAGE"
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
export const MODAL_OPENED = "MODAL_OPENED"
export const MODAL_CLOSED = "MODAL_CLOSED"
export const MODAL_CLEAR = "MODAL_CLEAR"
export const REFRESH_TOKEN_ALERT = "REFRESH_TOKEN_ALERT"